module.exports = __webpack_public_path__ + "89c12744356fa3074cda915ec6f5f95e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IT.svg
// module id = NWOt
// module chunks = 0